'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { MON569_SCREENS } from '../../constants/Tracking';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { useTrackRetail } from '../../selectors/RetailSelectors';
import { useAnchorLinkScroll } from '../../utils/customHooks';
import { useDocumentTitle } from '../../utils/DocumentUtils';
import { useQueryParamsEffect } from '../../utils/queryParamUtils';
import { useQueryParamTerm } from '../../utils/stateUtils';
import NavLayout, { HeaderBackdrop } from '../mon569-tabs/NavLayout';
import { OLAF } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { NavMarker } from 'react-rhumb';
import CurrencyPicker from '../common/CurrencyPicker';
import breakpoint from 'pricing-pages-unified-ui/utils/responsiveBreakpoints';
import FailedLoadBanner from '../loading/FailedLoadBanner';
import CrmSuiteTopSection from '../suite-page/CrmSuiteTopSection';
import PhoneSupport from '../common/PhoneSupport';
import { SuiteCalculator } from '../common/Calculator';
import Question from '../common/Question';
import FooterMicrocopy from 'ui-addon-upgrades/_core/common/components/FooterMicrocopy';
import { FaqsConfig } from '../../constants/FaqsConfig';
import { useParams } from 'react-router-dom';
import { NavItemEnum, tabIdToProductLevels } from '../../constants/Mon569SidenavConfig';
import CustomerSupport from '../common/CustomerSupport';
import Faq from '../common/Faq';
import PhoneSupportFooter from '../common/PhoneSupportFooter';
import PhoneSupportWrapper from '../common/phone-numbers/PhoneSupportWrapper';
const PageContainer = styled.div.withConfig({
  displayName: "Mon569SuitePage__PageContainer",
  componentId: "vp8o0x-0"
})(["background-color:", ";"], OLAF);
const TopSectionContainer = styled.div.withConfig({
  displayName: "Mon569SuitePage__TopSectionContainer",
  componentId: "vp8o0x-1"
})(["max-width:1000px;padding-top:", ";margin-left:50px;", ""], ({
  shouldShowEntPriceChangeBanner
}) => shouldShowEntPriceChangeBanner ? 0 : '40px', breakpoint.cs(_t || (_t = _`
    padding: 20px 20px 0;
    margin: auto;
  `)));
const StyledPageContentContainer = styled(TopSectionContainer).withConfig({
  displayName: "Mon569SuitePage__StyledPageContentContainer",
  componentId: "vp8o0x-2"
})(["&&&{max-width:1200px;margin:auto;padding-top:0;}"]);

const Mon569SuitePage = () => {
  useAnchorLinkScroll();
  useTrackRetail();
  useDocumentTitle('crmSuite');
  const {
    tab
  } = useParams();
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: MON569_SCREENS.CRM_SUITE,
      tab
    });
  }, [tab]);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  return /*#__PURE__*/_jsxs(PageContainer, {
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(HeaderBackdrop, {}), /*#__PURE__*/_jsx(CurrencyPicker, {}), /*#__PURE__*/_jsxs(NavLayout, {
      selectedNavItem: NavItemEnum.SUITE,
      children: [hasPricingAndPurchasingSucceeded && /*#__PURE__*/_jsx(NavMarker, {
        name: "SUITE_PAGE"
      }), /*#__PURE__*/_jsxs(TopSectionContainer, {
        shouldShowEntPriceChangeBanner: false,
        children: [/*#__PURE__*/_jsx(FailedLoadBanner, {
          hasFailed: hasPricingAndPurchasingFailed
        }), /*#__PURE__*/_jsx(CrmSuiteTopSection, {
          selectedTab: tab
        })]
      })]
    }), /*#__PURE__*/_jsxs(StyledPageContentContainer, {
      children: [/*#__PURE__*/_jsx(PhoneSupportWrapper, {
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          phoneSourceId: "crmsuite-middle",
          screen: `${MON569_SCREENS.CRM_SUITE}-${tab}`
        })
      }), /*#__PURE__*/_jsx(SuiteCalculator, {
        className: "m-top-10 m-bottom-10",
        initialProductLevel: tabIdToProductLevels[tab].find(productLevel => productLevel)
      }), /*#__PURE__*/_jsx(CustomerSupport, {}), /*#__PURE__*/_jsxs(Faq, {
        children: [FaqsConfig[NavItemEnum.SUITE].map((_ref) => {
          let {
            questionKey
          } = _ref,
              passthroughOptions = _objectWithoutPropertiesLoose(_ref, ["questionKey"]);

          return /*#__PURE__*/_jsx(Question, Object.assign({
            questionKey: questionKey
          }, passthroughOptions), questionKey);
        }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
      }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
        phoneSourceId: "crmsuite-footer",
        screen: `${MON569_SCREENS.CRM_SUITE}-${tab}`
      })]
    })]
  });
};

export default Mon569SuitePage;